import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=2e42f458&scoped=true&"
import script from "./AssetList.vue?vue&type=script&lang=js&"
export * from "./AssetList.vue?vue&type=script&lang=js&"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=2e42f458&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42f458",
  null
  
)

export default component.exports